import * as React from 'react';

import cn from 'classnames';

import { testAttr } from '@utils';

import { IBaseButtonProps } from './types';

import * as s from './BaseButton.scss';

export const BaseButton = ({ dataAttributes, testId, isDisabled, children, onClick, onMouseDown, className, type = 'button', ...props }: IBaseButtonProps) => {
	return (
		<button
			{...props}
			className={cn(s.button, className)}
			disabled={isDisabled}
			onClick={onClick}
			onMouseDown={onMouseDown}
			type={type}
			{...dataAttributes}
			{...testAttr(testId)}
		>
			{children}
		</button>
	);
};
